var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.4,4.9c1,1.3,1.5,2.7,1.5,4.2c0,1.9-0.7,3.5-2,4.8s-3,2-4.9,2s-3.5-0.7-4.9-2s-2-3-2-4.8s0.7-3.5,2-4.8s3-2,4.9-2 c1.5,0,3,0.5,4.3,1.5l1.1-1.1c0.4,0.3,0.7,0.7,1.1,1.1L13.4,4.9z M4.2,12.9c1,1,2.3,1.6,3.8,1.6s2.7-0.5,3.8-1.6s1.6-2.3,1.6-3.8 s-0.5-2.7-1.6-3.8S9.5,3.8,8,3.8S5.3,4.3,4.2,5.4S2.7,7.7,2.7,9.1S3.2,11.9,4.2,12.9z M10.3,0v1.5H5.7V0H10.3z M7.2,9.9V5.4h1.5 v4.6H7.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.8cd374646081527c9379c6af444af15d.svg";
export { ForwardRef as ReactComponent };